import printJS from 'print-js';

export const printBase64Pdf = (base64Str) => {
    printJS({
        printable: base64Str,
        type: 'pdf',
        base64: true
    });
}
